import { render, staticRenderFns } from "./SuperAdminDashboardLayout.vue?vue&type=template&id=18734a3c&"
import script from "./SuperAdminDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminDashboardLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports